import { Checkbox, FormControl, FormHelperText, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import { useEffect } from "react";

const ProffesionalInfoStep = ({ props }) => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} container >
                <Grid item>
                    {props.emptyFormProps.includes('specialty_ids') && <FormHelperText><b style={{ color: '#d32f2f' }}>This field is required</b></FormHelperText>}
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <FormControl fullWidth size="small">
                    <InputLabel id="specialty-select-label">Specialties</InputLabel>
                    <Select
                        labelId="specialty-select-label"
                        multiple
                        name="specialty_ids"
                        value={props.formData.specialty_ids}
                        onChange={props.handleSpecialtySelectChange}
                        input={<OutlinedInput label="Specialties" />}
                        renderValue={(selected) =>
                            props.specialtyFields
                                .filter(field => selected.includes(field.id))
                                .map(field => field.value)
                                .join(', ')
                        }
                    >
                        {props.specialtyFields
                            .sort((a, b) => a.value.localeCompare(b.value))
                            .map((field) => (
                                <MenuItem key={field.id} value={field.id}>
                                    <Checkbox checked={props.formData.specialty_ids.includes(field.id)} />
                                    <ListItemText primary={field.value} />
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </Grid>
            {props.isSurgeryChecked && (
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Please specify subspecialty"
                        name="specialty_surgery_subspecialty"
                        value={props.formData.specialty_surgery_subspecialty}
                        onChange={props.handleInputChange}
                        size="small"
                    />
                </Grid>
            )}
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Other (please specify)"
                    name="specialty_other"
                    value={props.formData.specialty_other}
                    onChange={props.handleInputChange}
                    size="small"
                />
            </Grid>
            <Grid mt={'7.5px'} item xs={12}>
                <Grid item xs={12} container >
                    <Grid item>
                        {props.emptyFormProps.includes('work_experience_range') && <FormHelperText><b style={{ color: '#d32f2f' }}>This field is required</b></FormHelperText>}
                    </Grid>
                </Grid>
                <FormControl fullWidth size="small">
                    <InputLabel id="workxp-select-label">Years of work experience</InputLabel>
                    <Select
                        name="work_experience_range"
                        labelId="workxp-select-label"
                        value={props.formData.work_experience_range}
                        onChange={props.handleYearsOfExpRangeChange}
                        input={<OutlinedInput label="Years of work experience" />}
                    >
                        {props.yearsOfExperienceRange
                            .map((el) => (
                                <MenuItem key={el.id} value={el.value}>
                                    <ListItemText primary={el.value} />
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    )
}

export default ProffesionalInfoStep;